import React from "react";

const HealthPlanComparison = () => {
  return (
    <div className="w-full overflow-x-auto">
      <h1 className="text-[16px] text-right mb-1">
        *Features Comparison Table
      </h1>
      <table className="min-w-[900px] w-full border-collapse bg-white text-sm mb-[80px]">
        {/* HEADER */}
        <thead>
          <tr className="bg-slate-100 font-semibold">
            <th className="sticky left-0 text-left px-4 py-3 border shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Features
            </th>
            <th className="px-4 py-3 border text-center">Essential<br />(₹999)</th>
            <th className="px-4 py-3 border text-center">Advantage<br />(₹4,999)</th>
            <th className="px-4 py-3 border text-center">Supreme<br />(₹9,999)</th>
            <th className="px-4 py-3 border text-center">Infinity<br />(₹14,999)</th>
            {/* <th className="px-4 py-3 border text-center">Prime Infinity<br />(₹19,999)</th> */}
          </tr>
        </thead>

        <tbody>
          {/* SECTION */}
          <tr className="bg-slate-50 font-semibold">
            <td
              colSpan={6}
              className="sticky left-0 z-10 bg-slate-50 px-4 py-3 border"
            >
              What’s included
            </td>
          </tr>

          {/* ROW */}
          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Tele Doctor Consultation: GP
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">6 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">10 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">10 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">10 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-unlimited">Unlimited</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Tele Doctor Consultation: Ayurvedic
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">5 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">5 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">10 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-unlimited">Unlimited</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Tele Doctor Consultation: Homeopathy
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">5 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">5 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">10 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-unlimited">Unlimited</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Tele Doctor Consultation: 18+ Specialist
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">4 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">4 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">10 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-unlimited">Unlimited</span>
            </td> */}
            
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Full Body Checkup (56 parameters)
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-wallet">Upto 50% off on 2 credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-unlimited">4 Credits</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Virtual Diabetic Consultation
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">1 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">1 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">1 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-wallet">2 Credits worth ₹2,000</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              2 Credit on In-person General Physician Clinic & Hospital Consultation or upto Rs.500 reimbursement for My Choice Doctor
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-wallet">6 Credit OR 500 per consultation</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              General Physician/CP Video Consultation
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">4 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">6 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">10 Credits</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Dental Check-up and Consultation
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">1 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-wallet">2 Credits worth ₹2,000</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Virtual Mental Wellness
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">1 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-wallet">4 Credits worth ₹4,800</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Tele Dietician Consultation
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">1 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-credit">2 Credits</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-wallet">4 Credits worth ₹4,800</span>
            </td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Diagnostic & Radiology Wallet
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-wallet">₹1,000</span>
            </td>
            <td className="border px-4 py-3 text-center">
              <span className="badge badge-wallet">₹2,000</span>
            </td>
            {/* <td className="border px-4 py-3 text-center">
              <span className="badge badge-wallet">₹3,500</span>
            </td> */}
          </tr>

          <tr className="bg-slate-50 font-semibold">
            <td
              colSpan={6}
              className="sticky left-0 z-10 bg-slate-50 px-4 py-3 border"
            >
              Inclusive Benefits
            </td>
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Applicable Risk Assessment
            </td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            {/* <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Applicable Health Reminder
            </td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            {/* <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Applicable Recorded Fitness sessions
            </td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            {/* <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td> */}
          </tr>

          <tr className="bg-slate-50 font-semibold">
            <td
              colSpan={6}
              className="sticky left-0 z-10 bg-slate-50 px-4 py-3 border"
            >
              Platform Benefits
            </td>
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Upto 50% off on Diagnostic & Radiology
            </td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            {/* <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Upto 20% off on Prescribed Medicines
            </td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            {/* <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td> */}
          </tr>

          <tr className="bg-slate-50 font-semibold">
            <td
              colSpan={6}
              className="sticky left-0 z-10 bg-slate-50 px-4 py-3 border"
            >
              Group Personal Accident Rider (Only for primary member)
            </td>
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              ₹15 Lakh Sum Insured
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            {/* <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Covered Accidental Death
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            {/* <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td> */}
          </tr>

          <tr>
            <td className="sticky left-0 z-10 bg-white px-4 py-3 border font-medium shadow-[2px_0_6px_rgba(0,0,0,0.06)]">
              Covered Permanent Total Disability (Upto 100% SI Paid on PTD)
            </td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            <td className="border px-4 py-3 text-center text-green-600 font-bold">✔</td>
            {/* <td className="border px-4 py-3 text-center text-red-600 font-bold">✖</td> */}
          </tr>
          
          
        </tbody>
      </table>

      {/* BADGE STYLES */}
      <style jsx>{`
      th{
        background-color: #215c5c;
        color: white
      }
        .badge {
          display: inline-block;
          padding: 4px 10px;
          border-radius: 9999px;
          font-weight: 600;
          font-size: 12px;
          white-space: nowrap;
        }
        .badge-credit {
          background: #e3f2fd;
          color: #0d47a1;
        }
        .badge-unlimited {
          background: #e8f5e9;
          color: #1b5e20;
        }
        .badge-wallet {
          background: #fff3e0;
          color: #e65100;
        }
      `}</style>
    </div>
  );
};

export default HealthPlanComparison;
